/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Chats_BodyInputs */



/**
* | output |
* | --- |
* | "Every conversation you've had, searchable and shareable with your team." |
*
* @param {Onboarding_Tour_Chats_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_chats_body = /** @type {((inputs?: Onboarding_Tour_Chats_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Chats_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jede Unterhaltung, die du geführt hast - durchsuchbar und mit deinem Team teilbar.")
	return /** @type {LocalizedString} */ ("Every conversation you've had, searchable and shareable with your team.")
});